export default "__VITE_ASSET__B1B80YwP__"